import { useNavigate } from 'react-router';
import { JobList } from '../components/JobList';

export default function JobsPage() {
  const navigate = useNavigate();

  return <JobList onNavigateToDetail={(orderId) => navigate(`/jobs/${orderId}`)} />;
}
